import React from 'react';
import { MoreHorizontal, CheckSquare, Square } from 'lucide-react';

const ChatItem = ({
  chat,
  selectedChatId,
  contextMenu,
  isSelectMode,
  selectedChatIds,
  viewMode,
  editingChatId,
  editingValue,
  onChatSelect,
  handleContextMenu,
  toggleChatSelection,
  handleMenuClick,
  setEditingValue,
  handleSaveRename,
  handleRenameKeyDown
}) => {
  const isActive = selectedChatId === chat.id;
  const isContextOpen = contextMenu.visible && contextMenu.chatId === chat.id;
  const isCompact = viewMode !== 'detailed';

  return (
    <div
      key={chat.id}
      className={`arrow-chat-row theme-sidebar-item group ${
        isCompact ? 'arrow-chat-row-compact' : 'arrow-chat-row-detailed'
      } ${isActive ? 'active' : ''} ${isContextOpen ? 'context-menu-open' : ''}`}
      onClick={isSelectMode ? (e) => toggleChatSelection(chat.id, e) : () => onChatSelect(chat.id)}
      onContextMenu={(e) => handleContextMenu(e, chat.id)}
    >
      {isSelectMode && (
        <div className="mr-3 flex-shrink-0">
          <button
            onClick={(e) => toggleChatSelection(chat.id, e)}
            className="p-1 rounded transition-colors hover:bg-gray-200 dark:hover:bg-gray-700"
          >
            {selectedChatIds.has(chat.id) ? (
              <CheckSquare size={16} className="text-blue-500" />
            ) : (
              <Square size={16} className="text-gray-400" />
            )}
          </button>
        </div>
      )}
      
      <div className="flex-grow min-w-0">
        {editingChatId === chat.id ? (
          <input
            type="text"
            value={editingValue}
            onChange={(e) => setEditingValue(e.target.value)}
            onBlur={() => handleSaveRename(chat.id)}
            onKeyDown={(e) => handleRenameKeyDown(e, chat.id)}
            onClick={(e) => e.stopPropagation()}
            className={`bg-transparent border-none outline-none w-full text-gray-900 dark:text-white ${
              viewMode === 'detailed'
                ? 'font-normal'
                : 'font-normal text-sm'
            }`}
            autoFocus
          />
        ) : (
          <h3 className={`arrow-chat-title truncate ${isCompact ? 'text-sm' : ''}`}>
            {chat.topic || 'Untitled Chat'}
          </h3>
        )}
        {!isCompact && editingChatId !== chat.id && (
          <div className="arrow-chat-meta">
            <span className="truncate">
              {chat.lastMessageTimeAgo || 'No messages yet'}
            </span>
            {chat.projectName && (
              <span className="arrow-chat-project-pill">
                {chat.projectName}
              </span>
            )}
          </div>
        )}
      </div>
      {!isSelectMode && (
        <button
          className="opacity-0 group-hover:opacity-100 p-0.5 rounded theme-more-button transition-all duration-200 ml-1 flex-shrink-0"
          onClick={(e) => handleMenuClick(e, chat.id)}
          aria-expanded={isContextOpen}
          data-arrow-menu-open={isContextOpen ? 'true' : undefined}
          data-arrow-tooltip-disabled={isContextOpen ? 'true' : undefined}
          title="More options"
        >
          <MoreHorizontal size={16} className="theme-text-primary" />
        </button>
      )}
    </div>
  );
};

export default ChatItem;
